export default __webpack_public_path__ + "static/media/t.65bd0fb0.svg";